import * as React from 'react';
import { BasicItem } from '../../models/search';
import '../../styles/h1Parity.scss';
import Image from '../Image/Image';

interface CategoryItem {
  category: BasicItem;
}

const CategoryItem = ({ category }: CategoryItem) => {
  return (
    <>
      <div className={'Sui-CategoryList--image-container'}>
        <Image
          className={'Sui-CategoryList--image'}
          url={category.image_url}
          alt=""
        />
      </div>
      <span className={'Sui-CategoryList--title'}>{category.name}</span>
    </>
  );
};

export default CategoryItem;
